import { gql } from 'urql';

const FetchDirectDepositAccountInfo = gql`
  query FetchDirectDepositAccountInfo {
    myAccounts {
      id
      forDirectDepositSetup {
        id
        nickname
        routingNumber
        accountNumber
        fullAccountNumber
        __typename
      }
      __typename
    }
  }
`;

export default FetchDirectDepositAccountInfo;
